/* eslint no-param-reassign: "off", no-console: "off" */
import Vuex from 'vuex';

const adminNetworkStore = {
  state: {
    nmsTypes: [],
    beams: []
  },
  mutations: {
    fetchNms(state, payload) {
      state.nmsTypes = payload;
    },
    fetchBeams(state, payload) {
      state.beams = payload;
    }
  },
  actions: {
    async fetchNms({ commit }) {
      try {
        const res = await fetch('/v2/info/nmstypes');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchNms', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async fetchBeams({ commit }) {
      try {
        const res = await fetch('/v2/info/beams');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchBeams', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async getTemplate({}, payload) {
      try {
        const res = await fetch('/v1/provision/networkTemplate', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) return { isSuccess: false, error: await res.text() };
        return { isSuccess: true, data: await res.text() };
      } catch (ex) {
        console.error(ex);
        return { isSuccess: false, error: ex.message };
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTemplate({}, payload) {
      try {
        const res = await fetch('/v1/provision/saveNetworkTemplate', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        const response = await res.text();
        if (!res.ok) return { isSuccess: false, error: response };
        return { isSuccess: true, response };
      } catch (ex) {
        console.error(ex);
        return { isSuccess: false, error: ex.message };
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async fetchNetworkRemoteMappings({}, payload) {
      try {
        const res = await fetch(`/v1/provision/networks/remote/${payload.remoteId}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        return data;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }, 
    // eslint-disable-next-line no-empty-pattern
    async addNetworkRemoteMapping({}, payload) {
      try {
        const res = await fetch('/v1/provision/networks/remote', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) return false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async fetchBaseModelByModemType({}, payload) {
      try {
        const res = await fetch(`/v2/info/basemodemtype/${payload.modemType}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.text();
        return data;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async fetchNetworkInventoryVisible({}) {
      try {
        const res = await fetch('/v2/info/networkinventoryvisible');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        return data;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {
    
  }
}
export default adminNetworkStore;
export const useAdminNetworkStore = () => new Vuex.Store(adminNetworkStore);
